   <mat-tab-group mat-align-tabs="left" #tabs (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Taglie Variante">
         <div class="@container max-w-full resize-x overflow-auto w-full px-4">
            <form class="form-container w-full mx-auto"
                  [formGroup]="varianteFrm">

               <div class="grid grid-cols-12 gap-3">

                  <div class="col-span-12">
                     <!--                     <h4 class="font-bold">Dati variante</h4>-->
                     <label class="lbl-header">Dati variante</label>
                  </div>

                  <div class="col-span-12 md:col-span-3">
                     <mat-label>Codice prodotto - Colore</mat-label>
                     <mat-form-field appearance="fill" class="w-full">
                        <input matInput type="text" formControlName="codice" [(ngModel)]="productVariant.data.codice">
                        <mat-error *ngIf="varianteFrm.get('codice')?.hasError('required')">
                           Il codice è <strong>obbligatorio</strong>
                        </mat-error>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 md:col-span-3">
                     <mat-label>Colore</mat-label>
                     <mat-form-field appearance="fill" class="w-full">
                        <mat-select formControlName="colore" placeholder="Colore" [(value)]="colorId">
                           <mat-option *ngFor="let colore of colori" value="{{colore.data.id}}">
                              {{colore.data.nome}}
                           </mat-option>
                        </mat-select>
                        <mat-error *ngIf="varianteFrm.get('colore')?.hasError('required')">
                           Il colore è <strong>obbligatorio</strong>
                        </mat-error>
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 md:col-span-3">
                     <mat-label>Descrizione Colore</mat-label>
                     <mat-form-field appearance="fill" class="w-full">
                        <input matInput type="text" formControlName="desc_colore" [(ngModel)]="productVariant.data.desc_colore">
                     </mat-form-field>
                  </div>

                  <div class="col-span-12 md:col-span-3 align-middle self-center">
                     <button class="ds-btn ds-btn-info" *ngIf="productVariant.data.id"
                             (click)="clickEditVariante()">Salva le modifiche</button>
                  </div>
               </div>
            </form>

            <div class="col-span-12 md:col-span-6 sm:col-span-3">
               <div class="" style="padding-left: 36px; padding-right: 36px;">
                  <label class="lbl-header">Tabella taglie prodotti</label>
                  <app-tab-taglie #tabTaglieComponent [prodottoId]="prodottoId" [pVarianteId]="pVarianteId" [pVariant]="[]"></app-tab-taglie>
               </div>
            </div>
         </div>

      </mat-tab>
      <div class="col-span-12 md:col-span-6 sm:col-span-3">
         <mat-tab label="Immagini Variante">
            <div class="col-span-12 md:col-span-6 sm:col-span-3">
               <div class="container w-full" style="padding-left: 36px; padding-right: 36px;">
                  <app-tab-immagini
                     #tabImmaginiComponent
                     [isVariante]="true"
                     [pVariantId]="pVarianteId"
                     [prodottoId]="prodottoId"
                     [pVariant]="[]">
                  </app-tab-immagini>
               </div>
            </div>
         </mat-tab>
      </div>
      <!--      <mat-tab label="Storico Assortimenti">-->
      <!--         <div class="container w-full" style="padding-left: 36px; padding-right: 36px;">-->
      <!--         <app-tab-storico-assortimenti [isVariante]="true" [vendorSlug]="vendorSlug" [pVariantId]="pVarianteId" [prodottoId]="prodottoId"></app-tab-storico-assortimenti>-->
      <!--         </div>-->
      <!--      </mat-tab>-->

   </mat-tab-group>
